/**
 * Keep ATC button prices (+ sticky / Shop Pay) in sync with the displayed
 * product price on every product surface (PDP, featured product, quick view).
 * Needed when WPD/Wholesale rewrites the visible price.
 */
(function () {
  if (window.__vpPriceSyncInit) return;
  window.__vpPriceSyncInit = true;

  function closestRoot(el) {
    return (
      el.closest(
        '[data-section-type="product"], [data-section-type="featured-product"], [data-section-type="api-product-quickview"], .product-page, .quickview__modal, [data-product-form-outer], product-info, .product'
      ) || document
    );
  }

  function parseCents(text) {
    if (!text) return null;
    var cleaned = String(text)
      .replace(/\s*(USD|US\$|CAD|EUR|GBP|MXN)\s*/gi, '')
      .replace(/[^\d.,-]/g, '')
      .trim();
    if (!cleaned) return null;
    var normalized = cleaned;
    if (cleaned.indexOf(',') > -1 && cleaned.indexOf('.') > -1) {
      normalized = cleaned.replace(/,/g, '');
    } else if (cleaned.indexOf(',') > -1 && cleaned.indexOf('.') === -1) {
      normalized = cleaned.replace(',', '.');
    }
    var amount = parseFloat(normalized);
    if (Number.isNaN(amount)) return null;
    return Math.round(amount * 100);
  }

  function formatShort(cents, currency) {
    try {
      if (window.themeCurrency && typeof themeCurrency.formatMoney === 'function' && window.theme && theme.moneyFormat) {
        var formatted = themeCurrency.formatMoney(cents, theme.moneyFormat);
        return String(formatted)
          .replace(/\.00\b/, '')
          .replace(/\s*[A-Z]{3}\s*$/, '')
          .trim();
      }
    } catch (e) {}
    var hasCents = Math.abs(cents % 100) > 0;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'USD',
        maximumFractionDigits: hasCents ? 2 : 0,
        minimumFractionDigits: hasCents ? 2 : 0
      }).format((cents || 0) / 100);
    } catch (e2) {
      return hasCents ? '$' + ((cents || 0) / 100).toFixed(2) : '$' + Math.round((cents || 0) / 100);
    }
  }

  function bindButton(buttonPriceEl) {
    if (buttonPriceEl.dataset.vpPriceBound === '1') return;
    buttonPriceEl.dataset.vpPriceBound = '1';

    var root = closestRoot(buttonPriceEl);
    var productPriceEl = root.querySelector('[data-product-price]');
    if (!productPriceEl) return;

    var stickyPriceEl = document.querySelector('[data-vp-sticky-price]');
    var shopPayEl = root.querySelector('[data-vp-shop-pay-terms]');
    var qtyInput = root.querySelector('input[name="quantity"]');

    function currentUnitCents() {
      return (
        parseCents(productPriceEl.textContent) ||
        Number(buttonPriceEl.getAttribute('data-unit-price')) ||
        Number(productPriceEl.getAttribute('data-wpd-variant-price')) ||
        0
      );
    }

    function sync() {
      var unit = currentUnitCents();
      if (!unit) return;
      buttonPriceEl.setAttribute('data-unit-price', String(unit));
      var qty = Math.max(Number(qtyInput && qtyInput.value) || 1, 1);
      var currency = buttonPriceEl.getAttribute('data-currency') || 'USD';
      buttonPriceEl.textContent = formatShort(unit * qty, currency);
      if (stickyPriceEl && document.contains(productPriceEl)) {
        stickyPriceEl.textContent = productPriceEl.textContent.trim();
      }
      if (shopPayEl) {
        var shopifyPrice = Number(shopPayEl.getAttribute('data-shopify-price')) || 0;
        var mismatched = shopifyPrice > 0 && Math.abs(unit - shopifyPrice) > 1;
        shopPayEl.style.display = mismatched ? 'none' : '';
        if (mismatched) shopPayEl.setAttribute('data-vp-price-mismatch', '');
        else shopPayEl.removeAttribute('data-vp-price-mismatch');
      }
    }

    sync();
    if (qtyInput) {
      qtyInput.addEventListener('input', sync);
      qtyInput.addEventListener('change', sync);
    }

    var obs = new MutationObserver(function () {
      window.requestAnimationFrame(sync);
    });
    obs.observe(productPriceEl, {
      childList: true,
      characterData: true,
      subtree: true,
      attributes: true
    });

    window.setTimeout(sync, 500);
    window.setTimeout(sync, 1500);
    window.setTimeout(sync, 3000);
  }

  function scan() {
    document.querySelectorAll('[data-button-price]').forEach(bindButton);
  }

  document.addEventListener('theme:variant:change', function () {
    window.setTimeout(scan, 50);
    window.setTimeout(scan, 300);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  new MutationObserver(scan).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
